// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"bdff0dce","68":"c27b94c4","122":"fe219f36","198":"c641744b","357":"f7768b24","732":"8f16d096","740":"c807b8e9","747":"c674800f","788":"efc3fdd4","801":"1723ec89","882":"d608ad10","936":"4b862f17"}[chunkId] + ".chunk.js";
};